// a list of attributes pointing to other nodes
// taken from IVR Nodes defs
// https://github.com/sagansystems/supernova/blob/1fa64e54fd0da93f46df783359a8db70e8774625/services/telephony/IVR.md
export const NODE_LINKS_MAPPER = {
  IVR_NODE_HTTP: ['nextId', 'errorNodeId'],
  IVR_NODE_HTTP2: ['nextId', 'errorNodeId'],
  IVR_NODE_INPUT: ['nextId'],
  IVR_NODE_MENU: ['badSelectionNodeId', { prefixPath: 'menu', postfixPath: 'nextId' }],
  IVR_NODE_MESSAGE: ['nextId'],
  IVR_NODE_NUMBER_MATCH: ['defaultNextId', { prefixPath: 'numberMatchers', postfixPath: 'nextId' }],
  IVR_NODE_SCHEDULE: ['defaultNextId', 'defaultOffId', { prefixPath: 'nodeSchedules', postfixPath: 'nodeId' }],
  IVR_NODE_SMS: ['nextId', 'errorNodeId'],
  IVR_NODE_VARIABLE: ['nextId', 'errorNodeId'],
  IVR_NODE_VARIABLE_MATCH: ['defaultNextId', 'errorNodeId', { prefixPath: 'variableMatches', postfixPath: 'nextId' }],
  IVR_NODE_VOICE_AUTOMATION: ['errorNodeId', 'handoffNodeId', 'closedNodeId'],
};
